/* eslint-disable */

/**
 * The platform new-order alert: one short play of dragon_sound.mp3 per order.
 *
 * Separate from the branch bell in store.js (tring_tring.mp3, which loops until the
 * order is acknowledged). This one never loops — a call centre gets a burst of orders
 * and a looping alarm per order would be unusable.
 */

const SOUND_PATH = 'sounds/dragon_sound.mp3'
const GAP_MS = 1200

let audio = null
let unlocked = false
let playing = false
const queue = []
const heardKeys = new Set()

function element () {
    if (!audio) {
        audio = new Audio(SOUND_PATH)
        audio.preload = 'auto'
    }
    return audio
}

/**
 * Browsers refuse to play audio until the user has interacted with the page. Prime the
 * element with a muted play/pause during a real gesture (the login click, or the first
 * click anywhere after a reload) so later alerts are allowed through.
 */
export function unlock () {
    if (unlocked) return Promise.resolve(true)
    const a = element()
    a.muted = true
    return a.play().then(() => {
        a.pause()
        a.currentTime = 0
        a.muted = false
        unlocked = true
        return true
    }).catch(() => {
        a.muted = false
        return false
    })
}

export function isUnlocked () {
    return unlocked
}

/**
 * Play once for this key. Repeats of a key are ignored, so a redelivered Ably message
 * can never double-ring even if it slips past the store's own dedupe.
 */
export function play (key) {
    if (!unlocked) return
    if (key !== undefined && key !== null) {
        if (heardKeys.has(key)) return
        heardKeys.add(key)
        if (heardKeys.size > 500) {
            heardKeys.delete(heardKeys.values().next().value)
        }
    }
    queue.push(key)
    drain()
}

// Queue rather than overlap: a dinner-rush burst becomes a sequence, not a chord.
function drain () {
    if (playing || queue.length === 0) return
    playing = true
    queue.shift()
    const a = element()
    a.currentTime = 0
    const started = a.play()
    if (started && typeof started.catch === 'function') started.catch(() => {})
    setTimeout(() => {
        playing = false
        drain()
    }, GAP_MS)
}

export function reset () {
    queue.length = 0
    heardKeys.clear()
    playing = false
}
